import { EEntities } from '@/types'
import { IHomeTableItem } from '@/types/data-objects/items'

export const HomeTableProps = {
  type: {
    type: String as () => EEntities,
    required: true,
  },

  tableData: {
    type: Array as () => IHomeTableItem[],
    default: (): IHomeTableItem[] => [],
  },

  isLoading: {
    type: Boolean,
    default: false,
  },

  searchQuery: {
    type: String,
    default: '',
  },

  fromAll: {
    type: Boolean,
    default: false,
  },

  fromEntityHome: {
    type: Boolean,
    default: false,
  },
}
